import hatchIcon from '@/assets/svg/hatch.svg'

const HATCH_IMAGE_ID = 'hatch'

const STREET_COUNT_ZERO_FILTER: any[] = ['==', ['get', 'streetCount'], 0]

export const STREET_COUNT_NOT_ZERO_FILTER: any[] = [
  'any',
  ['!', ['has', 'streetCount']],
  ['>', ['get', 'streetCount'], 0]
]

export function registerHatchImage(map: any): void {
  if (map.hasImage(HATCH_IMAGE_ID)) return

  const hatchImg = new Image(8, 8)
  hatchImg.onload = () => map.addImage(HATCH_IMAGE_ID, hatchImg)
  hatchImg.src = hatchIcon
}

// 町丁目を持たない町域は、来店者の有無によらず斜線で塗る
export function createHatchLayer(id: string, source: any) {
  return {
    id,
    type: 'fill',
    source,
    layout: {},
    filter: STREET_COUNT_ZERO_FILTER,
    paint: {
      'fill-pattern': HATCH_IMAGE_ID,
      'fill-opacity': 0.6
    }
  }
}
